export enum DidYouForgetTracingConstants {
  capability = 'orders',
  event = 'DYF Page Load',
  dyfApiCallEvent = 'DYF Call',
}
